import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {HttpClientModule} from '@angular/common/http';


import {AppComponent} from './app.component';
import {BricoFooterComponent} from './components/brico-footer/brico-footer.component';
import {CardInputComponent} from './components/card-input/card-input.component';
import {InfoDisplayComponent} from './components/info-display/info-display.component';
import {BricoHeaderComponent} from './components/brico-header/brico-header.component';
import {FormsModule} from '@angular/forms';

@NgModule({
  declarations: [
    AppComponent,
    BricoFooterComponent,
    CardInputComponent,
    InfoDisplayComponent,
    BricoHeaderComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule {
}
